import React from 'react'

export default (props) =>
  <svg {...props} width='21' height='21' viewBox='0 0 21 21' fill='none'>
    <circle opacity='0.5' cx='10.5' cy='10.5' r='10.5' fill='#E66135' />
    <rect x='5' y='11' width='2' height='11' transform='rotate(-90 5 11)' fill='white' />
  </svg>
